const buttonHTML = `<button class="news-vj-search-lookup__button" disabled="disabled">
        <svg class="bbc-news-visual-journalism-icon--search" width="22" height="22" viewBox="0 0 32 32"><path d="M12.99 4c2.4 0 4.6 1 6.4 2.6 3.6 3.6 3.6 9.2 0 12.8-1.6 1.6-4 2.6-6.4 2.6s-4.6-1-6.4-2.6c-1.8-1.8-2.6-4-2.6-6.4s1-4.6 2.6-6.4c1.8-1.6 4-2.6 6.4-2.6m0-4c-3.4 0-6.6 1.2-9.2 3.8-5 5-5 13.4 0 18.4 2.6 2.6 5.8 3.8 9.2 3.8s6.6-1.2 9.2-3.8c5-5 5-13.4 0-18.4-2.6-2.6-5.8-3.8-9.2-3.8z"></path><path d="M31.99 28.4l-3.6 3.6-9-9.2 1.6-1.8 1.6-2"></path></svg>
        <div class="news-vj-search-lookup__loading-spinner"></div>
    </button>`;

const getLookupHTML = ({ id = 'news-vj-search-lookup', button = true, inline = false, minChars = 2, pattern = ''}) => {

const patternAttrib = `${pattern ? `pattern="${pattern}"` : ''}`;
const minCharsAttrib = `${minChars ? `minlength="${minChars}"` : ''}`;
const requiredAttrib = (pattern || minChars) ? 'required' : '';
const validation = `${patternAttrib} ${minCharsAttrib} ${requiredAttrib}`;

  return `
<div
    class="news-vj-search-lookup__wrapper ${button ? 'news-vj-search-lookup__wrapper--button' : ''}"
    id="${id}__wrapper"
    role="combobox"
    aria-expanded="false"
>
  <div
    class="news-vj-search-lookup__screen-reader-announcement off-screen"
    aria-atomic="true"
    aria-live="polite"
    role="status"
  ></div>
  <input
    aria-owns="${id}__suggestions"
    autocomplete="off"
    class="news-vj-search-lookup__input"
    id="${id}"
    name="input-autocomplete"
    type="text"
    role="textbox"
    ${validation}
  >
  ${button ? buttonHTML : ''}
  <ul
    class="news-vj-search-lookup__menu news-vj-search-lookup__menu--${inline
    ? 'inline'
    : 'overlay'}"
    id="${id}__suggestions"
    role="listbox"
  >
  </ul>
</div>
`
};

export default getLookupHTML;
